var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"text-center"},[_vm._v("\n    "+_vm._s(_vm.$t("Property payment successful"))+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("\n    "+_vm._s(_vm.$t(
        "One of our friendly consultants will contact you within 24hrs regarding your lease.",
      ))+"\n  ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-cta btn-orange btn-block",attrs:{"to":"/accommodation"}},[_vm._v("\n    "+_vm._s(_vm.$t("View other listings"))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }